import { ref } from 'vue'

/** IDs de workspaces abertos via Super Admin (sessão) — removíveis da lateral sem deletar. */
const previewIds = ref(new Set())

export function markSuperAdminPreview(workspaceId) {
  if (workspaceId == null) return
  const next = new Set(previewIds.value)
  next.add(Number(workspaceId))
  previewIds.value = next
}

export function isSuperAdminPreview(workspaceId) {
  if (workspaceId == null) return false
  return previewIds.value.has(Number(workspaceId))
}

export function clearSuperAdminPreview(workspaceId) {
  if (workspaceId == null) return
  const next = new Set(previewIds.value)
  next.delete(Number(workspaceId))
  previewIds.value = next
}

export function clearAllSuperAdminPreviews() {
  previewIds.value = new Set()
}

export function useSuperAdminWorkspacePreview() {
  return {
    previewIds,
    markSuperAdminPreview,
    isSuperAdminPreview,
    clearSuperAdminPreview
  }
}
